export default "__VITE_ASSET__BSv2VEKl__"